export default "__VITE_ASSET__CB94eS74__"